import * as React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Button, Dropdown, Segment, Header, Form } from 'semantic-ui-react';
import { ISubscriptionData, fetchSubscriptions, } from 'store/modules/subscriptions';
import axios from 'axios';
import { ApiConfig as CONFIG_API } from 'config/config';
import { REST } from 'fluent-forever-shared-types';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

interface ISubscriptionContainerProps {
	load?: () => void;
	subscribe?: () => void;
	pay?: () => void;
}

interface ISubscriptionContainerState {
	subscriptions: ISubscriptionData[];
	loading: boolean;
}

const mapStateToProps = (state: any): ISubscriptionContainerState => ({
	loading: state.subscriptions.loading,
	subscriptions: state.subscriptions.data,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	load: () => dispatch(fetchSubscriptions()),
}, dispatch);

const urlEncode = (data: any) => {
	const str: string[] = [];
	for (const p in data) {
		if (data.hasOwnProperty(p) && (!(data[p] === undefined || data[p] === null))) {
			str.push(encodeURIComponent(p) + "=" + (data[p] ? encodeURIComponent(data[p]) : ""));
		}
	}
	return str.join("&");
}

// Default checkout options/handler
const checkoutOptions = {
	success(hostedPageId: string) {
		console.log('Subscription Hosted-Page Id:' + hostedPageId);
	},
	close: () => {
		// this.setState({ loading: false });
		console.log("Subscription Closed");
	},
	step(step: any) {
		console.log("Subscription Step:", step);
	},
}

class SubscriptionContainer extends React.Component<ISubscriptionContainerProps> {

	public readonly state = {
		clients: [
			{ key: 1, text: 'Single Language', value: 'single-language-monthly' },
			{ key: 3, text: 'Multi-Language ', value: 'm-lang-monthly' },
			{ key: 4, text: 'Multi-Language + Family', value: 'm-lang-yearly' },
		],
		loading: false,
		first_name: 'John',
		last_name: 'Doe',
		email_name: 'john@gmail.com',
		client_id: '12345',
		subscription_id: 'Izy9TB3R004fqejIi',
		subscription_plan_id: 'single-language-monthly'
	};

	private readonly chargebeeInstance: ChargebeeInstance;

	constructor(props: ISubscriptionContainerProps) {
		super(props);
		this.chargebeeInstance = Chargebee.init({ site: "fluent-forever-test" });
	}

	public handleChange = (event: any) => {
		const target = event.target;
		const value = target.value;
		const name = target.name;
		this.setState({ [name]: value });
	}

	public handleDDLChange = (event: any, data: any) => {
		const value = data.value;
		const name = data.name;
		this.setState({ [name]: value });
	}

	// =============== SUBSCRIPTION (CHARGEBEE) HANDLERS =============/
	public subscribe = () => {
		this.chargebeeInstance.openCheckout({
			...checkoutOptions,
			hostedPage: () => {
				const data = {
					first_name: this.state.first_name,
					last_name: this.state.last_name,
					email: this.state.email_name,
					client_id: this.state.client_id,
					plan_id: this.state.subscription_plan_id
				};
				const body = urlEncode(data);
				return axios.post(CONFIG_API.url + REST.PATH.SUBSCRIPTION_START, body)
					.then((response) => {
						return response.data.hosted_page;
					})
			},
		});
	}

	public changeSubscription = () => {
		this.chargebeeInstance.openCheckout({
			...checkoutOptions,
			hostedPage: () => {
				const data = {
					subscription_id: this.state.subscription_id,
					plan_id: this.state.subscription_plan_id
				};
				const body = urlEncode(data);
				return axios.post("http://localhost:8000/change", body).then((response) => {
					return response.data.hosted_page;
				})
			},
		});
	}

	public createPortal = (section = 'sub_details') => {
		console.log(this.chargebeeInstance);
		const portal = this.chargebeeInstance.createChargebeePortal();
		portal.openSection({
			sectionType: section,
			params: {
				subscriptionId: this.state.subscription_id
			}
		});
	}

	componentDidMount() {
		this.subscribe();
	}

	public render() {
		const { clients } = this.state;
		console.log(this.state);
		return (
			<div style={{ width: 600 }}>
				<Segment secondary={true}>
					<Header>Subscription (Chargebee) Proof of Concept Testing Module</Header>
					<Form>
						<Form.Field>
							<label>Client Id</label>
							<input placeholder='Custom Id' name="client_id" value={this.state.client_id} onChange={this.handleChange} />
						</Form.Field>
						<Form.Field>
							<label>First Name</label>
							<input placeholder='First Name' name="first_name" value={this.state.first_name} onChange={this.handleChange} />
						</Form.Field>
						<Form.Field>
							<label>Last Name</label>
							<input placeholder='Last Name' name="last_name" value={this.state.last_name} onChange={this.handleChange} />
						</Form.Field>
						<Form.Field>
							<label>Email</label>
							<input placeholder='Email' name="email_name" value={this.state.email_name} onChange={this.handleChange} />
						</Form.Field>
						<Form.Field>
							<label>Plan</label>
							<Dropdown placeholder='Plan' name="subscription_plan_id" multiple={false} selection={true} options={clients} value={this.state.subscription_plan_id} onChange={this.handleDDLChange} />
						</Form.Field>
						<Form.Field>
							<label>Customer Id/Subscription Id</label>
							<input placeholder='Id' name="subscription_id" value={this.state.subscription_id} onChange={this.handleChange} />
						</Form.Field>
						<Button primary={true} onClick={this.subscribe}>Subscribe</Button>
						<Button primary={true} onClick={this.changeSubscription}>Change</Button>
						<Button primary={true} onClick={this.changeSubscription}>Redeem Code</Button>
						<Button primary={true} disabled={true} >Cancel</Button>
						<Button primary={true} onClick={() => this.createPortal()} >Portal</Button>
					</Form>
				</Segment>
			</div>
		);
	}
}

// export default Subscriptions;
export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(SubscriptionContainer);



// WEBPACK FOOTER //
// ./src/components/containers/Subscriptions.tsx